var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActivity(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 230,
    height: 170,
    viewBox: "0 0 230 170",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M207.405 135.346C205.398 130.187 203.899 124.711 202.261 118.927C201.157 115.03 199.378 110.668 195.519 109.44C191.767 108.244 187.726 110.721 185.418 113.914C183.109 117.106 181.946 120.978 179.972 124.387C176.394 130.566 170.055 133.156 164.817 127.723C157.334 119.963 153.967 109.386 149.222 99.9204C145.778 93.0489 142.894 85.0046 138.554 78.6715C131.936 69.0141 122.862 60.7798 110.794 60.7798C103.145 61.9394 96.4046 68.7183 91.8432 77.1898C87.2819 85.6614 84.6207 95.7367 82.3532 105.787C78.2298 124.066 75.2079 142.769 72.1914 161.446C72.1914 161.446 224.445 159.67 224.446 159.67C223.841 159.677 220.108 154.684 219.392 153.993C213.546 148.333 210.038 142.112 207.405 135.346Z",
    fill: "#E2E2E2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M178.492 144.399C178.191 150.331 171.689 160.701 165.714 160.402C159.738 160.103 156.552 149.248 156.854 143.316C157.155 137.385 163.518 107.703 169.494 108.002C175.469 108.301 178.793 138.467 178.492 144.399Z",
    fill: "#FE1E3F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M169.222 112.151L165.609 160.408",
    stroke: "#011738",
    strokeWidth: 0.867,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M164.825 143.746C163.447 146.7 162.4 149.8 161.766 153.028C161.445 154.666 161.243 156.44 162.001 157.933C162.83 159.564 164.669 160.515 166.508 160.81C171.001 161.531 175.495 158.843 178.129 155.214C180.762 151.586 181.903 147.151 182.95 142.822C183.774 139.413 184.584 135.955 186.137 132.779C186.804 131.417 190.702 126.161 188.858 124.798C186.335 122.861 179.031 124.968 174.351 129.959C170.495 134.07 167.179 138.695 164.825 143.746Z",
    fill: "#FFC957"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M167.158 160.408C167.158 160.408 172.449 139.633 185.222 127.718",
    stroke: "#011738",
    strokeWidth: 0.867,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M195.774 138.671C195.321 139.443 194.472 139.969 193.701 140.382C192.751 140.891 191.739 141.338 190.762 141.771C189.506 142.327 188.206 142.901 187.008 143.617C186.133 144.14 185.357 144.729 184.705 145.36C185.735 143.137 186.937 141.195 188.355 139.46C190.22 137.176 192.135 136.02 194.049 136.02C194.093 136.02 194.137 136.021 194.181 136.022C194.773 136.038 195.234 136.177 195.551 136.436C196.2 136.967 196.175 137.99 195.774 138.671Z",
    fill: "#1A55B5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M198.271 151.928C197.542 152.505 196.575 152.651 195.726 152.718C194.678 152.801 193.603 152.792 192.565 152.785C191.231 152.775 189.852 152.765 188.498 152.943C187.51 153.075 186.579 153.318 185.738 153.662C187.598 151.873 189.486 150.451 191.472 149.335C194.085 147.868 196.253 147.569 197.918 148.444C197.957 148.464 197.996 148.485 198.033 148.507C198.541 148.794 198.882 149.146 199.046 149.554C199.381 150.391 198.916 151.418 198.271 151.928Z",
    fill: "#1A55B5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M192.58 158.318C191.984 158.225 191.451 157.792 191.008 157.38C190.463 156.874 189.941 156.307 189.437 155.759C188.789 155.056 188.12 154.329 187.385 153.71C186.848 153.258 186.292 152.893 185.738 152.625C187.389 152.703 188.901 152.979 190.334 153.461C192.218 154.095 193.401 155.08 193.852 156.39C193.862 156.421 193.872 156.451 193.882 156.481C194.011 156.891 194.031 157.245 193.942 157.535C193.758 158.13 193.106 158.401 192.58 158.318Z",
    fill: "#1A55B5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M178.514 160.408C178.514 160.408 178.574 147.499 193.997 136.539",
    stroke: "#2A294F",
    strokeWidth: 0.78,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M177.996 160.927C177.996 160.927 182.865 150.549 196.06 150.549",
    stroke: "#2A294F",
    strokeWidth: 0.78,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M185.738 152.626C185.738 152.626 188.245 152.424 193.48 156.776",
    stroke: "#2A294F",
    strokeWidth: 0.78,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.9663 161.316C85.3594 147.623 81.7325 133.924 77.492 120.662C75.1008 113.184 72.4625 105.735 68.7981 99.7538C65.1331 93.7712 60.2772 89.3573 55.4036 89.3883C47.8929 90.8482 43.0475 98.2962 39.8701 106.545C37.7863 111.954 36.7762 118.507 35.3023 124.224C33.2716 132.098 32.2068 140.664 28.3062 147.554C25.5762 152.377 21.3782 151.147 18.5491 146.813C16.9878 144.422 15.8865 141.578 14.1389 139.394C12.3907 137.211 9.63462 135.789 7.41539 137.165C5.13424 138.58 4.45144 142.159 4.14459 145.298C3.68903 149.957 3.28985 154.362 2.54347 158.584C2.38093 159.503 2.20014 160.413 2 161.316H88.9663Z",
    fill: "#E2E2E2"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.3709 142.323C55.1577 139.755 52.3563 137.539 51.4729 134.298C50.8272 131.93 51.3366 129.424 51.5885 126.982C51.8405 124.539 51.752 121.839 50.1816 119.959C48.8876 118.411 46.8438 117.738 44.8776 117.313C42.9113 116.887 40.8593 116.618 39.1147 115.612C36.2818 113.978 36.8466 111.198 35.3251 108.76C33.619 106.024 29.648 102.534 26.2444 104.351C22.64 106.275 23.2112 112.117 25.6086 114.697C27.199 116.408 29.2353 118.05 29.4693 120.381C29.8217 123.89 25.8253 127.049 26.9243 130.399C27.7366 132.872 30.8355 133.722 32.3663 135.824C33.8807 137.903 33.5755 140.816 32.6839 143.232C31.7923 145.648 30.3881 147.883 29.8337 150.398C28.6988 155.547 32.7138 159.105 37.2891 160.252C41.4936 161.307 50.5606 160.81 50.5606 160.81C53.7969 159.671 57.3845 156.811 59.1634 153.686C60.5073 151.326 60.6936 148.333 59.6521 145.821C59.1151 144.528 58.2946 143.395 57.3709 142.323Z",
    fill: "#FFC957"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8691 109.037C29.8691 109.037 45.2303 133.134 46.901 159.889",
    stroke: "#011738",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3056 142.075C16.5359 141.859 16.8711 141.743 17.3013 141.73C17.3338 141.729 17.3658 141.728 17.3983 141.728C18.79 141.728 20.1821 142.692 21.5392 144.595C22.5699 146.04 23.4444 147.659 24.1934 149.511C23.7192 148.985 23.1548 148.494 22.5185 148.059C21.6467 147.462 20.702 146.983 19.7887 146.52C19.0774 146.159 18.3415 145.787 17.6506 145.363C17.0904 145.019 16.4725 144.581 16.143 143.937C15.8519 143.37 15.8335 142.517 16.3056 142.075Z",
    fill: "#FE1E3F"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9553 151.194C14.0808 150.897 14.3432 150.641 14.7337 150.432C14.7631 150.416 14.7925 150.401 14.8219 150.386C16.1032 149.75 17.7707 149.967 19.7813 151.035C21.3089 151.846 22.7612 152.881 24.1915 154.181C23.5445 153.931 22.8285 153.754 22.0687 153.659C21.0273 153.529 19.9662 153.536 18.9403 153.543C18.141 153.549 17.3144 153.555 16.5087 153.496C15.8553 153.447 15.1115 153.34 14.5505 152.92C14.0552 152.55 13.6972 151.802 13.9553 151.194Z",
    fill: "#FE1E3F"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0078 158.272C16.9407 158.061 16.9561 157.803 17.0528 157.505C17.06 157.483 17.0676 157.461 17.0753 157.438C17.413 156.486 18.3007 155.769 19.7143 155.308C20.7888 154.958 21.9226 154.757 23.1602 154.7C22.7453 154.895 22.3283 155.161 21.9256 155.489C21.3741 155.939 20.8722 156.468 20.3866 156.98C20.0085 157.378 19.6171 157.79 19.2078 158.159C18.8758 158.458 18.4762 158.773 18.0295 158.841C17.6355 158.9 17.1454 158.704 17.0078 158.272Z",
    fill: "#FE1E3F"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3214 161.446C28.3214 161.446 28.2774 151.624 16.9668 143.285",
    stroke: "#011738",
    strokeWidth: 0.78,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8702 160.408C29.8702 160.408 26.2539 152.625 16.4512 152.625",
    stroke: "#011738",
    strokeWidth: 0.78,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6773 154.701C23.6773 154.701 21.839 154.524 18 158.332",
    stroke: "#011738",
    strokeWidth: 0.78,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.783 52.6166C113.418 52.9091 110.102 54.9577 110.102 54.9577L107.75 51.8055L108.45 48.2114L113.514 48.5414C113.514 48.5414 114.399 51.2236 114.4 51.2243C114.611 51.8611 114.235 52.2554 113.783 52.6166Z",
    fill: "#FFC9A2"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M114.352 49.2421L115.207 51.5576L112.594 52.5261C112.096 52.7248 111.541 52.763 111.017 52.6332C109.864 52.347 109.115 51.3244 109.26 50.2334L109.429 48.9609L114.352 49.2421Z",
    fill: "#FFC9A2"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.223 52.3442L114.548 52.7088L115.821 50.3562C116.069 49.9309 115.951 49.3696 115.557 49.1011C115.164 48.8334 114.643 48.9606 114.395 49.3851L112.223 52.3442Z",
    fill: "#FFC9A2"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.478 60.9541L107.085 61.9619L105.514 73.5065L110.656 73.697L111.478 60.9541Z",
    fill: "#283044"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M165.046 69.8987L157.703 69.0284L159.383 56.4565L166.727 57.3275C170.413 57.7644 173.025 60.9329 172.561 64.4043C172.097 67.8762 168.733 70.3356 165.046 69.8987Z",
    fill: "#FE9280"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M165.429 67.1391L158.085 66.3L157.703 69.0607L165.046 69.9004C168.733 70.3216 172.099 67.9499 172.562 64.6032C172.629 64.1274 172.63 63.6588 172.578 63.2026C171.517 65.8051 168.593 67.5009 165.429 67.1391Z",
    fill: "#777470"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M156.796 68.4499L80.1641 58.7917L81.8169 45.9624L158.45 55.6199L156.796 68.4499Z",
    fill: "#D6D5D5"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.4902 50.5649L80.7915 58.7053L82.4018 45.9624L67.4902 50.5649Z",
    fill: "#FFF4DD"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.5762 51.5547L80.6106 59.8001L80.9966 56.6437L67.5762 51.5547Z",
    fill: "#777470"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.4715 49.7534L65.998 51.1073L69.9883 53.5013L70.4715 49.7534Z",
    fill: "#2A294F"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M163.465 69.949L156.959 69.1755L158.654 56.4565L165.16 57.2301L163.465 69.949Z",
    fill: "#0C6C9C"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M163.471 69.9492L161.432 69.6674L163.12 54.9575L165.16 55.2393L163.471 69.9492Z",
    fill: "#0C6C9C"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M161.027 69.949L80.1641 59.6376L80.5687 56.4565L161.432 66.7674L161.027 69.949Z",
    fill: "#777470"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M161.774 59.4549L80.9102 49.1441L81.3148 45.9624L162.178 56.2738L161.774 59.4549Z",
    fill: "#777470"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M163.216 69.9492L161.432 69.6839L161.883 65.4517L163.668 65.7169L163.216 69.9492Z",
    fill: "#777470"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M131.609 95.4349L132.679 92.0426L136.265 91.6972C136.924 91.609 137.507 92.1035 137.569 92.7993C137.629 93.4965 137.144 94.1329 136.486 94.2203L131.609 95.4349Z",
    fill: "#FFC9A2"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M129.785 91.8772L131.697 94.6852L135.338 93.9561L131.281 87.939L130.495 88.4523C129.345 89.204 129.027 90.7368 129.785 91.8772Z",
    fill: "#FFC9A2"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M134.023 48.3711C130.199 42.9993 120.564 44.4319 120.816 53.039C120.816 53.0642 120.819 53.0912 120.82 53.1164C120.796 54.2078 120.833 55.3187 120.537 56.3457C120.387 56.8645 120.128 57.3475 119.735 57.6957C119.346 58.048 118.84 58.2555 118.308 58.3645C117.771 58.4788 117.191 58.5082 116.595 58.623C115.994 58.7415 115.407 58.9531 114.876 59.2573C113.812 59.8546 112.943 60.833 112.544 61.9919C111.782 64.2903 112.392 66.9487 114.188 68.678C114.64 69.1024 115.164 69.4629 115.739 69.7214C116.313 69.9905 116.964 70.0913 117.493 70.1945C118.605 70.4278 119.73 70.7367 120.878 70.9542L120.91 70.8592C119.852 70.3891 118.81 69.8961 117.69 69.5227C117.105 69.3251 116.604 69.2108 116.153 68.9406C115.7 68.6839 115.282 68.3679 114.931 67.9863C114.224 67.2295 113.71 66.2957 113.416 65.2992C113.123 64.3044 113.062 63.2276 113.353 62.2369C113.639 61.2533 114.329 60.3951 115.24 59.8253C115.694 59.5387 116.199 59.3306 116.728 59.2028C117.263 59.0738 117.845 59.0205 118.436 58.8698C119.029 58.7233 119.611 58.4349 120.043 57.9923C120.48 57.5515 120.729 56.9829 120.853 56.4213C120.939 56.0204 120.978 55.6206 120.991 55.222C121.095 56.8264 120.951 58.4548 119.238 59.0715C118.251 59.4267 117.289 59.4273 116.371 60.0176C115.473 60.5956 114.759 61.4514 114.41 62.4409C113.336 65.4856 116.135 69.423 119.425 69.7595C120.786 69.899 122.148 70.2167 123.495 70.4495C123.871 70.5145 129.167 71.5603 129.21 71.4384L135.336 53.9652L134.023 48.3711Z",
    fill: "#0C50BE"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M134.068 90.9372L145.776 82.7357L144.142 78.1943L132.355 88.3629L134.068 90.9372Z",
    fill: "#283044"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M142.262 81.4043C142.79 82.5265 144.123 83.0064 145.24 82.4755C146.356 81.944 146.833 80.6044 146.305 79.4816C145.778 78.3594 144.444 77.8796 143.328 78.411C142.211 78.9419 141.734 80.2816 142.262 81.4043Z",
    fill: "#283044"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M143.057 82.6919L146.52 79.3078L136.516 68.2022C135.38 66.689 133.15 66.521 131.793 67.8457C130.437 69.1697 130.584 72.8522 132.105 73.99L143.057 82.6919Z",
    fill: "#283044"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M126.389 67.3511L130.189 67.7005L130.862 59.0551L127.063 58.7056L126.389 67.3511Z",
    fill: "#FFC296"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M107.601 71.4533C106.369 71.5363 105.437 72.6087 105.519 73.8469C105.602 75.0863 106.668 76.0231 107.9 75.9407C109.133 75.8578 110.065 74.7854 109.982 73.5471C109.9 72.3078 108.833 71.3704 107.601 71.4533Z",
    fill: "#283044"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M107.006 71.8569L109.407 75.9459L124.092 71.8546C125.891 71.4158 126.867 68.1546 126.159 66.5101C125.45 64.8656 123.385 64.2048 121.787 65.1097L107.006 71.8569Z",
    fill: "#283044"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M128.609 87.9392L136.004 69.6105C136.377 68.1096 135.376 66.6157 133.859 66.4078L123.243 63.9766C121.726 63.7687 120.366 64.9401 120.331 66.4858L116.697 86.4733L128.609 87.9392Z",
    fill: "#283044"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M127.542 49.7104C126.205 51.1954 123.8 51.8208 123.234 53.1827L123.113 53.8114C123.113 53.8401 123.112 53.8683 123.113 53.8981L123.1 53.8782L122.734 55.7854C122.269 58.1978 124.121 60.4842 126.87 60.8916C129.619 61.299 132.223 59.6733 132.688 57.261L133.1 55.1147C132.817 52.9298 128.269 52.7615 127.542 49.7104Z",
    fill: "#FFC9A2"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M131.625 55.8949C131.523 56.5073 131.933 57.0877 132.541 57.1903C133.151 57.2941 133.727 56.8814 133.83 56.2689C133.933 55.6565 133.523 55.0767 132.914 54.9735C132.305 54.8697 131.728 55.2818 131.625 55.8949Z",
    fill: "#FF4F48"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M121.881 87.8439L127.135 101.34L122.114 164.396H118.258L113.715 100.948L116.715 87.1895L121.881 87.8439Z",
    fill: "#25448C"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M121.172 87.939V101.419L145.745 164.396H148.758L135.611 99.0413L128.027 88.7742L121.172 87.939Z",
    fill: "#25448C"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M121.405 167.395H119.68V163.647H121.916L121.405 167.395Z",
    fill: "#FF746F"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118.985 165.896L120.046 166.258L121.031 165.896L121.916 168.144H113.715L116.798 167.02L118.985 165.896Z",
    fill: "#2A294F"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M148.276 167.395H150.249L149.08 163.647H146.521L148.276 167.395Z",
    fill: "#FF746F"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M149.453 165.896L148.392 166.258L147.406 165.896L146.521 168.144H154.723L151.639 167.02L149.453 165.896Z",
    fill: "#2A294F"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124.154 74.8216C124.154 76.6844 122.651 78.1945 120.799 78.1945C118.945 78.1945 117.443 76.6844 117.443 74.8216C117.443 72.9583 118.945 71.4482 120.799 71.4482C122.651 71.4482 124.154 72.9583 124.154 74.8216Z",
    fill: "#283044"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124.152 63.9526L124.58 70.6989L130.863 64.7582L124.152 63.9526Z",
    fill: "#FFC296"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M137.881 49.8548C137.349 49.1629 136.7 48.6029 135.98 48.216C134.812 47.587 133.491 47.6553 132.419 46.7119L133.257 55.3404C134.794 54.8917 134.703 58.2766 132.925 57.3415C132.925 57.3415 129.404 58.8814 128.068 62.2517C127.151 64.5148 126.998 67.1542 127.238 68.6653C127.667 71.3701 129.914 72.7723 132.464 71.9755C133.985 71.5003 135.224 70.3248 136.102 68.968C139.184 64.2074 141.238 56.3904 138.602 51.0185C138.396 50.5998 138.154 50.21 137.881 49.8548Z",
    fill: "#0C50BE"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M107.883 48.2114L107.781 48.869C107.568 50.2413 108.469 51.533 109.794 51.7541L110.828 51.9271C112.153 52.1475 113.4 51.2138 113.612 49.8415L113.715 49.1847L107.883 48.2114Z",
    fill: "#FFC9A2"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M128.36 56.0807C127.997 55.9254 125.576 55.6206 125.283 55.7303C124.968 55.8488 124.839 56.1283 124.924 56.3648C125.007 56.6019 125.265 56.7954 125.563 56.9326C126.239 57.2436 127.159 57.2943 127.899 57.0599C128.181 56.9708 128.446 56.8353 128.568 56.6422C128.689 56.4492 128.623 56.193 128.36 56.0807Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivity);
export default __webpack_public_path__ + "static/media/activity.a892688d35e9ac743a2ed76f54e8bd9c.svg";
export { ForwardRef as ReactComponent };